package org.hs_soft.runmynesto.domain.model.general



enum class FooterType {
    STANDARD,
    ALIGNED,
    NONE
}